// extracted by mini-css-extract-plugin
module.exports = {"main":"RuleItem_main__3WkAu","lists":"RuleItem_lists__QegXV","list":"RuleItem_list__2KoZ0","label":"RuleItem_label__wEhrT"};